import { useEffect, useState } from "react";
import { formatDistanceToNow } from "date-fns";
import { Send } from "lucide-react";
import { toast } from "sonner";
import { api, formatError, TIER_LABEL } from "../../lib/api";

export function Comments({ postId, onAdded }) {
  const [items, setItems] = useState([]);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/posts/${postId}/comments`).then((r) => setItems(Array.isArray(r.data) ? r.data : [])).catch(() => setItems([]));
  }, [postId]);

  const submit = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/posts/${postId}/comments`, { text });
      setItems((p) => [...p, data]);
      setText("");
      onAdded?.();
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="feed-comments-panel" className="border-t border-[#0E1B3D]/[0.08] px-5 sm:px-7 py-5">
      <div className="space-y-4 max-h-72 overflow-y-auto pr-1" data-lenis-prevent>
        {items.length === 0 && <p className="text-sm text-[#4A5878]">Be the first to comment.</p>}
        {items.map((c) => (
          <div key={c.id} data-testid="feed-comment-item" className="text-sm">
            <span className={`font-semibold ${c.is_creator ? "text-[#D7263D]" : "text-[#0E1B3D]"}`}>{c.is_creator ? "Katie" : c.user_name}</span>
            {c.user_tier && !c.is_creator && <span className="ml-2 font-mono-x text-[0.6rem] tracking-[0.15em] uppercase text-[#D7263D]/80">{TIER_LABEL[c.user_tier]}</span>}
            <span className="ml-2 text-xs text-[#6B7894]">{c.created_at ? formatDistanceToNow(new Date(c.created_at), { addSuffix: true }) : ""}</span>
            <p className="mt-1 text-[#26355A] leading-relaxed">{c.text}</p>
          </div>
        ))}
      </div>
      <form onSubmit={submit} className="mt-4 flex items-center gap-3">
        <input data-testid="feed-comment-input" value={text} maxLength={1000} onChange={(e) => setText(e.target.value)} placeholder="Write a comment…"
          className="flex-1 bg-transparent border-b border-[#0E1B3D]/20 focus:border-[#D7263D] outline-none py-2 text-sm text-[#0E1B3D] placeholder:text-[#6B7894]" />
        <button data-testid="feed-comment-submit-btn" disabled={busy} className="p-2 text-[#D7263D] hover:text-[#B81D31] disabled:opacity-50" aria-label="Post comment"><Send className="w-4 h-4" /></button>
      </form>
    </div>
  );
}
